export const MALICIOUS_LABELS = ['Scam', 'Phish / Hack'];

export const WHITELISTED_LABELS = ['IBC: Donate'];
